import { ImageLogType } from 'plugin-drilling-widgets/webapp/js/types'
import {useEffect, useState} from 'react'

export default function (): [ImageLogType[], boolean] {
    const [imageLogTypes, setImageLogTypes] = useState<ImageLogType[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal

        setLoading(true)

        fetch(`/rest/lookup/imagelog_type`, {signal})
            .then(r => r.json())
            .then(imageLogTypes => {
                setLoading(false)
                setImageLogTypes(imageLogTypes.entries)
            })
            .catch(e => {
                console.error(e.message, e)
            })

        return () => controller.abort()
    }, [])

    return [imageLogTypes, loading]
}
